import React, { useRef, useState } from "react";
import { Modal } from "antd";
import ReactCrop, { centerCrop, makeAspectCrop } from "react-image-crop";

import { canvasPreview } from "../../../CurrentCourse/ImageCorp/canvasPreview";
import { useDebounceEffect } from "../../../CurrentCourse/ImageCorp/useDebounceEffect";

import "react-image-crop/dist/ReactCrop.css";

// Выходной размер миниатюры - карточка в конструкторе/превью 160px, исходное фото
// с телефона даёт кроп в несколько тысяч пикселей и несколько мегабайт base64 на
// КАЖДЫЙ ответ; несколько таких строк в состоянии React (перерисовка на каждое
// нажатие клавиши где угодно в форме) - и браузер не успевает перерисовывать
// картинки на очередном ре-рендере (визуально это выглядит как "размытие"/рывки),
// плюс такой payload тяжело гонять через API. 480px с запасом хватает под 2x retina.
const THUMB_SIZE = 480;

// Полноразмерная версия для lightbox - без обрезки в квадрат (детализированные
// схемы/скриншоты не всегда квадратные), но с потолком по стороне, иначе фото
// с телефона в несколько мегабайт база64 будет так же тормозить форму, как раньше
// тормозили некэшированные миниатюры.
const FULL_MAX_SIDE = 2000;

// Модалка выбора области картинки при добавлении варианта ответа "Выбор картинки".
// Зона выбора всегда квадратная (aspect=1), не настраиваемая - под требование 1:1.
function centerSquareCrop(mediaWidth, mediaHeight) {
    return centerCrop(
        makeAspectCrop({ unit: "%", width: 90 }, 1, mediaWidth, mediaHeight),
        mediaWidth,
        mediaHeight,
    );
}

const AnswerImageCrop = ({ open, imageSrc, onCancel, onSave }) => {
    const [crop, setCrop] = useState();
    const [completedCrop, setCompletedCrop] = useState();
    const imgRef = useRef(null);
    const previewCanvasRef = useRef(null);

    const onImageLoad = (e) => {
        const { width, height } = e.currentTarget;
        setCrop(centerSquareCrop(width, height));
    };

    useDebounceEffect(
        async () => {
            if (
                completedCrop?.width &&
                completedCrop?.height &&
                imgRef.current &&
                previewCanvasRef.current
            ) {
                canvasPreview(imgRef.current, previewCanvasRef.current, completedCrop, 1, 0);
            }
        },
        100,
        [completedCrop],
    );

    const handleSave = () => {
        const source = previewCanvasRef.current;
        const original = imgRef.current;
        if (!source || !original) return;

        const size = Math.min(THUMB_SIZE, source.width);
        const thumbCanvas = document.createElement("canvas");
        thumbCanvas.width = size;
        thumbCanvas.height = size;
        const thumbCtx = thumbCanvas.getContext("2d");
        thumbCtx.imageSmoothingQuality = "high";
        thumbCtx.drawImage(source, 0, 0, size, size);

        const scale = Math.min(1, FULL_MAX_SIDE / Math.max(original.naturalWidth, original.naturalHeight));
        const fullCanvas = document.createElement("canvas");
        fullCanvas.width = Math.round(original.naturalWidth * scale);
        fullCanvas.height = Math.round(original.naturalHeight * scale);
        const fullCtx = fullCanvas.getContext("2d");
        fullCtx.imageSmoothingQuality = "high";
        fullCtx.drawImage(original, 0, 0, fullCanvas.width, fullCanvas.height);

        onSave({
            thumbnail: thumbCanvas.toDataURL("image/jpeg", 0.85),
            full: fullCanvas.toDataURL("image/jpeg", 0.9),
        });
    };

    return (
        <Modal
            open={open}
            onCancel={onCancel}
            footer={null}
            title="Выберите область для миниатюры (пропорция 1:1). Полная картинка сохранится без обрезки."
            className="answer_image_crop_modal"
            destroyOnClose
        >
            {imageSrc &&
                <div className="answer_image_crop">
                    <ReactCrop
                        crop={crop}
                        aspect={1}
                        onChange={(_, percentCrop) => setCrop(percentCrop)}
                        onComplete={(c) => setCompletedCrop(c)}
                    >
                        <img ref={imgRef} src={imageSrc} alt="" onLoad={onImageLoad} />
                    </ReactCrop>
                    <div className="answer_image_crop_preview">
                        <span>Предпросмотр</span>
                        <canvas ref={previewCanvasRef} />
                    </div>
                    <div className="answer_image_crop_actions">
                        <div className="btn_save" onClick={handleSave}>Применить</div>
                        <div
                            className="btn_cansel btn_save"
                            style={{ backgroundColor: "grey" }}
                            onClick={onCancel}
                        >
                            Отмена
                        </div>
                    </div>
                </div>}
        </Modal>
    );
};

export default AnswerImageCrop;
